import styled from '@emotion/styled';
import { css } from '@emotion/core';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { NavLink } from 'react-router-dom';

import {
  sidebarWidth,
  pageContentWithSidebarWidth,
  typography,
  spacing,
} from '$variables/theme';

import COLORS from '$variables/colors';

const linkCss = css`
  padding: ${spacing.xxSmall} ${spacing.medium};
  transition: all 0.25s ease;

  line-height: 14px;
  font-size: 14px;
  height: 40px;

  display: inline-flex;
  text-decoration: none;
  box-sizing: border-box;

  border-radius: ${spacing.xxSmall};
  font-weight: ${typography.fontWeightBold};

  align-items: center;
  text-transform: none;
  width: 100%;
  justify-content: flex-start;
`;

export const StyledPaper = styled(Paper)`
  margin-top: ${spacing.xxxGiant};
  margin-right: ${spacing.xLarge};
  width: ${sidebarWidth};
  align-self: flex-start;

  @media (max-width: ${pageContentWithSidebarWidth}) {
    display: none;
  }
`;

export const StyledLink = styled(NavLink)`
  ${linkCss}

  color: ${COLORS.black};
  background: ${COLORS.white};

  &:hover {
    opacity: 1;
    background: ${COLORS.beige};
  }

  &.selected {
    color: ${COLORS.purple};
    background: ${COLORS.purpleHighlight};

    &:hover {
      background: ${COLORS.purpleHighlight};
    }
  }
`;

export const DisabledLink = styled.div`
  ${linkCss}

  cursor: default;
  color: ${COLORS.grey1};
  background: ${COLORS.white};
`;

export const StyledList = styled(List)`
  padding: 0;
`;

export const StyledListItem = styled(ListItem)`
  &:first-of-type {
    padding: ${spacing.xxSmall};
  }

  padding: 0 ${spacing.xxSmall} ${spacing.xxSmall};
`;
